export default (theme) => ({
    root: {},
    overlay: {
        zIndex: 2001,
    },
    loadingLoader: {
        padding: '40px 0',
        textAlign: 'center',
    },
});
